// Mill Visualizer — viewBox geometry constants and helpers.
// All layout math is in viewBox units, NOT pixels. The SVG is rendered with
// preserveAspectRatio so the parent container governs the actual size.

export const STAGE_HEIGHT = 170;
// 100 viewBox units per stand. The actual viewBox width is computed in
// VisualizerStage as `stands.length * STAND_SLOT_WIDTH`, so the SVG slots
// always line up 1:1 with the KPI strip cells underneath regardless of the
// stand count returned by the SP.
export const STAND_SLOT_WIDTH = 100;

export const STAND_BLOCK_WIDTH = 56;
export const STAND_BLOCK_HEIGHT = 130;

export const PASS_LINE_Y = 85;
export const STAND_TOP_Y = PASS_LINE_Y - STAND_BLOCK_HEIGHT / 2;
export const STAND_BOTTOM_Y = PASS_LINE_Y + STAND_BLOCK_HEIGHT / 2;

// Section split — stands 1..ROUGHING_LAST_POSITION render with the
// roughing background band; everything after gets the finishing band.
export const ROUGHING_LAST_POSITION = 8;

// Width (px) reserved at the LEFT of the visualizer, the KPI strip and
// the trend grid for the "property column" / "pre-heating furnace" slot.
// Keeps the three components horizontally aligned: the table's pinned-left
// column, the SVG's left padding, and the KPI strip's first grid column
// all share this width. Single source of truth — if the table's pinned
// column ever changes width, change it HERE and the visualizer follows.
export const PROPERTY_COLUMN_WIDTH = 100;

export const standCenterX = (positionFloat: number): number =>
	(positionFloat - 1) * STAND_SLOT_WIDTH + STAND_SLOT_WIDTH / 2;

export const standLeftX = (position: number): number =>
	standCenterX(position) - STAND_BLOCK_WIDTH / 2;

export const standRightX = (position: number): number =>
	standCenterX(position) + STAND_BLOCK_WIDTH / 2;
